<template>
    <div class="p-6 text-left">
        <form @submit.prevent="submitForm">
            <div v-for="(employer, index) in employers" :key="index" class="mb-6">
                <label class="block font-medium text-gray-700 mb-2">{{ employer.name }}</label>
                <div class="border-2 rounded-xl p-4 text-center cursor-pointer transition duration-300" :class="[
                    'border-dashed',
                    draggingIndex === index ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-400'
                ]" @dragover.prevent="draggingIndex = index" @dragleave.prevent="draggingIndex = null"
                    @drop.prevent="handleDrop($event, index)" @click="$refs[`input_${index}`][0].click()">
                    <p class="text-sm text-gray-500">
                        Drag and drop a file here, or <span class="text-blue-600 underline">click to upload</span>
                    </p>
                    <p v-if="employer.file" class="mt-2 text-green-600 text-sm">
                        {{ employer.file.name }}
                    </p>
                    <progress v-if="employer.progress !== null" :value="employer.progress" max="100"
                        class="mt-2 w-full h-2 rounded bg-gray-200"></progress>
                    <!-- <div v-if="employer.success" class="text-green-600 text-sm mt-2">✔️ Uploaded successfully</div>
                    <div v-if="employer.error" class="text-red-600 text-sm mt-2">❌ {{ employer.error }}</div> -->
                </div>
                <input type="file" accept=".pdf,.doc,.docx" class="hidden" :ref="'input_' + index"
                    @change="handleFileChange($event, index)" />
            </div>
            <div class="mt-6 flex justify-center">
                <button type="submit" :disabled="isLoading"
                    class="bg-blue-600 text-white py-2 px-6 rounded-xl hover:bg-blue-700 transition duration-300 disabled:opacity-50">
                    {{ isLoading ? "Uploading..." : "Submit All CVs" }}
                </button>
            </div>
        </form>
        <div class="h-full flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
export default {
    name: "employers-form",
    props: ["token", "participatingEmployers"],
    data() {
        return {
            employers: this.participatingEmployers.map((employer) => ({
                id: parseInt(employer.id),
                name: employer.partner.en_company_name,
                file: null,
                progress: null
            })),
            isLoading: false,
            draggingIndex: null,
        };
    },
    methods: {
        handleFileChange(event, index) {
            const file = event.target.files[0];
            if (file) {
                this.setFile(index, file);
            }
        },
        handleDrop(event, index) {
            const file = event.dataTransfer.files[0];
            if (file) {
                this.setFile(index, file);
            }
            this.draggingIndex = null;
        },
        setFile(index, file) {
            this.employers[index] = {
                ...this.employers[index],
                file,
                progress: 0,
            };

            // Animate progress
            const duration = 1000; // total time in ms
            const steps = 20;
            const increment = 100 / steps;
            const intervalTime = duration / steps;

            let currentProgress = 0;
            const interval = setInterval(() => {
                currentProgress += increment;

                if (currentProgress >= 100) {
                    currentProgress = 100;
                    clearInterval(interval);
                }

                this.employers[index].progress = Math.round(currentProgress);
            }, intervalTime);
        },
        async submitForm() {
            this.isLoading = true;

            let hasAtleastOneDocument = false;

            for (const employer of this.employers) {
                if (employer.file) {
                    hasAtleastOneDocument = true;
                    break;
                }
            }

            if (!hasAtleastOneDocument) {
                this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: 'Kindly upload at least one CV for one of the participating employers before proceeding.',
                });
                this.isLoading = false;
                return;
            }

            const validFiles = this.employers.filter(employer => employer.file !== null).map(employer => ({
                id: employer.id,
                file: employer.file
            }));

            const CREATE_MUTATION = gql`
                mutation UploadEventEmployersDocuments($token: String!, $input: [EventEmployerDocument!]!) {
                    uploadEventEmployersDocuments(token: $token, input: $input) {
                        error
                        message
                    }
                }
            `;

            let error_msg = null;
            let success_msg = null;

            try {
                await this.$apollo.mutate({
                    mutation: CREATE_MUTATION,
                    variables: {
                        token: this.token,
                        input: validFiles,
                    },
                    context: {
                        headers: {
                            'content-type': 'multipart/form-data',
                        },
                    },
                }).then((data) => {
                    if (data.data.uploadEventEmployersDocuments.error) {
                        error_msg = data.data.uploadEventEmployersDocuments.message;
                    } else {
                        success_msg = data.data.uploadEventEmployersDocuments.message;
                    }
                }).catch((error) => {
                    console.log(error)
                    error_msg = error.message;
                })

            } catch (error) {
                console.log(error);
                error_msg = error.message || "Please try again later.";
            }

            if (error_msg === null) {
                this.$swal.fire({
                    icon: 'success',
                    title: 'Congratulations!',
                    text: success_msg,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        error_msg = null;
                        success_msg = null;
                        this.$emit('close');
                    }
                })
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error_msg,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        error_msg = "";
                        success_msg = "";
                        this.$emit('close');
                    }
                })
            }

            this.isLoading = false;
        },
    },
};
</script>

<style scoped></style>
